import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.ROUTER_BASE,
	routes: [
		{
			path: '/',
			name: 'index',
            component: Index
		}, {
			name: 'about',
            path: '/about',
            component: Index
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js